enum UnmappedRecordStatus {
  UNMAPPED = 'UNMAPPED',
  MAPPED = 'MAPPED',
  ADDED = 'ADDED',
  RESOLVED_HIDDEN = 'RESOLVED_HIDDEN',
  DELETED = 'DELETED',
}

export default UnmappedRecordStatus;
